import { styled } from "@mui/material";
import * as TooltipPrimitive from "@radix-ui/react-tooltip";
import {
  COLOR_TOKENS,
  FONT_TOKENS,
  RADIUS_TOKENS,
  SPACING_TOKENS,
} from "~/designSystem/constants/token";

export const StyledTooltipContent = styled(TooltipPrimitive.Content)`
  height: 26px;
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  background: ${COLOR_TOKENS.inverted[12]};
  padding: 0px ${SPACING_TOKENS.spacing["layout-spacing-6"]};
  gap: ${SPACING_TOKENS.spacing["layout-spacing-6"]};
  border-radius: ${RADIUS_TOKENS.radius["radius-6"]};

  /* shadow-light-mode/3 */
  box-shadow:
    0px 0px 0px 1px ${COLOR_TOKENS.gray.a4},
    0px 2px 3px -2px ${COLOR_TOKENS.gray.a3},
    0px 3px 12px -4px ${COLOR_TOKENS.black.a2},
    0px 4px 16px -8px ${COLOR_TOKENS.black.a2};
`;

export const StyledTooltipContentText = styled("p")`
  text-edge: cap;
  leading-trim: both;
  font-style: normal;
  white-space: pre-wrap;
  color: ${COLOR_TOKENS.core.silver[1]};
  font-family: ${FONT_TOKENS.family.text};
  font-size: ${FONT_TOKENS.size["size-1"]};
  font-weight: ${FONT_TOKENS.weight.medium};
  line-height: ${FONT_TOKENS.height["height-2"]};
  letter-spacing: ${FONT_TOKENS.spacing["spacing-1"]};
`;
